// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xngGaRegistrationEvent from "@guestsupply/App/Handlers/GoogleAnalytics/LogIn/Registration";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

// <xng-change>: add google event
const mapStateToProps = () => ({});

const mapDispatchToProps = {
    xngGaRegistrationEvent,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
// </xng-change>: add google event

const AccountApplicationPage = ({
    id,
    // xng-change: add google event
    xngGaRegistrationEvent,
}: Props) => {
    // xng-change: add google event
    useEffect(() => {
        const button = document.getElementById("btnSubmit");
        const form = document.getElementById("frmMain") as HTMLFormElement;

        button?.addEventListener("click", () => {
            const formData = new FormData(form);
            let userEmail = "";
            let accountAppFor = "";
            for (const [name, value] of formData.entries()) {
                if (name === "TextBoxCompletingEmail") {
                    userEmail = value as string;
                } else if (name === "DropDownListTypeOfBusiness") {
                    accountAppFor = value as string;
                }
            }

            if (userEmail && accountAppFor) {
                xngGaRegistrationEvent({
                    userEmail,
                    accountAppFor,
                });
            }
        });
    }, []);

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AccountApplicationPage),
    definition: {
        displayName: "Account Application",
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [],
    },
};

export default pageModule;
